// import scripts
import "./Account/login";
import "./Account/signoutRedirect";
import "./Register/register";
import "./Shared/carousel";
import "./Shared/Components/CultureSelection/cultureSelection";
import "./Shared/signinRedirect";
import "./Shared/site";
import {UserAgent} from "./Shared/userAgent";

export {UserAgent};

// import scss
import "./Account/login.scss";
import "./Register/register.scss";
import "./site.scss";

// import libraries
import "bootstrap";
import "bootstrap-select/dist/css/bootstrap-select.min.css";
import "bootstrap-select/dist/js/bootstrap-select.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "font-awesome/css/font-awesome.min.css";
import "jquery";
import "zxcvbn/dist/zxcvbn.js";

// Import images
import "../Content/img/BG_Cows.png";
import "../Content/img/BG_Crop.png";
import "../Content/img/BG_Pigs.png";
import "../Content/img/envelope.svg";
import "../Content/img/favicon.ico";
import "../Content/img/favicon.png";
import "../Content/img/lock.svg";
import "../Content/img/logo-agrovision-final-loginpage.svg";
import "../Content/img/logo-agrovision.svg";

// Fonts
import "../Content/fonts/Poppins-Regular.ttf";